import KunLoading1 from './src/index'

KunLoading1.install = function (Vue){
	Vue.component(KunLoading1.name, KunLoading1);
}

export default KunLoading1;
